<template>
  <div class>
    <footer class="footer-bs">
      <div class="row">
        <div class="col-md-3 footer-brand animated fadeInLeft">
          <h2>
            <img style="width: 130px;" src="../../public/img/logos/fulllogo.png" />
          </h2>
          <p>Copyright © 2021 Vortex Co. All Rights Reserved</p>
        </div>
        <div class="col-md-4 footer-nav animated fadeInUp">
          <h4>Menu —</h4>
          <b-container>
            <b-row>
              <b-col>
                <ul class="pages">
                  <li>
                    <a @click="setActive(3)" href="/commercial">Commercial</a>
                  </li>
                  <li>
                    <a @click="setActive(4)" href="/academy">Academy</a>
                  </li>
                  <li>
                    <a @click="setActive(5)" href="/store">Store</a>
                  </li>
                </ul>
              </b-col>
              <b-col>
                <ul class="list">
                  <li>
                    <a @click="setActive(2)" href="/about_us">About</a>
                  </li>
                  <li>
                    <a @click="setActive(7)" href="/contact_us">Contact</a>
                  </li>
                  <li>
                    <a @click="setActive(6)" href="/team">AUV</a>
                  </li>
                  <li>
                    <a @click="setActive(6)" href="/team">Team</a>
                  </li>
                </ul>
              </b-col>
            </b-row>
          </b-container>
        </div>
        <div class="col-md-2 footer-social animated fadeInDown">
          <h4>Follow Us</h4>
          <ul>
            <li>
              <a target="_blank" href="https://www.facebook.com/vortexroboticsegypt">Facebook</a>
            </li>
            <li>
              <a target="_blank" href="https://www.linkedin.com/company/vortexrobotics">Linkedin</a>
            </li>
            <li>
              <a target="_blank" href="https://www.instagram.com/vortex_robotics/">Instagram</a>
            </li>
            <li>
              <a
                target="_blank"
                href="https://www.youtube.com/channel/UC9NpCNSHz5B3BiXDqfqXrYg"
              >Youtube</a>
            </li>
          </ul>
        </div>
        <div class="col-md-3 footer-ns animated fadeInRight">
          <h4>Newsletter</h4>
          <p>What do you want to search for?</p>
          <!-- <div class="input-group">
            <input type="text" class="form-control" placeholder="Search for..." />
          </div>-->
          <Dropdown
            :options="searchOptions"
            v-on:selected="validateSelection"
            v-on:filter="getDropdownValues"
            :disabled="false"
            name="components"
            :maxItem="5"
            placeholder="Search for..."
            autocomplete="false"
          ></Dropdown>
        </div>
      </div>
    </footer>
    <section style="text-align:center; margin:2px auto;">
      <p>
        Brought to you by
        <a target="_blank" href="https://linkedin.com/in/IslamGamaal">Islam Gamal</a>
      </p>
    </section>
  </div>
</template>

<script>
import Dropdown from "vue-simple-search-dropdown";

export default {
  data() {
    return {
      searchOptions: [
        {
          id: 0,
          name: "Our Products",
          page: "/commercial",
          htmlId: "rovs_cards"
        },
        {
          id: 1,
          name: "Our Services",
          page: "/commercial",
          htmlId: "services_pre_div"
        },
        {
          id: 2,
          name: "Vortex News / Blog",
          page: "/home",
          htmlId: "myBtnContainer"
        },
        {
          id: 3,
          name: "Robosub - in Vortex Academy",
          page: "/academy",
          htmlId: "academy-competitions"
        },
        {
          id: 4,
          name: "Robosub - in AUV",
          page: "/auv",
          htmlId: ""
        },
        {
          id: 5,
          name: "SWIFT AUV",
          page: "/swift-auv",
          htmlId: ""
        },
        {
          id: 6,
          name: "SWIFT AUV - Mechanical Specs",
          page: "/swift-auv",
          htmlId: "Mechanical"
        },
        {
          id: 7,
          name: "SWIFT AUV - Electrical Specs",
          page: "/swift-auv",
          htmlId: "#Electrical"
        },
        {
          id: 8,
          name: "SWIFT AUV - Software Specs",
          page: "/swift-auv",
          htmlId: "Software"
        },
        {
          id: 9,
          name: "SWIFT AUV - Localization Specs",
          page: "/swift-auv",
          htmlId: "Localization"
        },
        {
          id: 10,
          name: "SWIFT AUV - General Specs",
          page: "/swift-auv",
          htmlId: "General"
        },
        {
          id: 11,
          name: "Robosub - AUV Team members",
          page: "/auv",
          htmlId: "members"
        },
        {
          id: 12,
          name: "Robosub - AUV Team",
          page: "/auv",
          htmlId: "team-info"
        },
        {
          id: 13,
          name: "Robosub - AUV Team Moments (Gallery)",
          page: "/auv",
          htmlId: "auv-moments"
        },
        {
          id: 14,
          name: "Contact Us",
          page: "/contact_us",
          htmlId: ""
        }
      ]
    };
  },
  name: "Footer",
  components: {
    Dropdown
  },
  props: {
    msg: String
  },
  methods: {
    validateSelection(selectedItem) {
      if (selectedItem.page) {
        this.$router.push({ path: selectedItem.page });
        var thishtmlId = selectedItem.htmlId;
        setTimeout(() => {
          if (document.getElementById(thishtmlId))
            document.getElementById(thishtmlId).scrollIntoView();
          else window.scrollTo(0, 0);
        }, 2000);
      }
    },
    getDropdownValues() {
      return [];
    },
    setActive(id) {
      document.documentElement.style.scrollBehavior = "auto";
      setTimeout(
        () => (document.documentElement.style.scrollBehavior = "smooth"),
        1000
      );
      document.getElementById("nav" + id).style.borderTop = "5px solid #00264A";
      var i;
      for (i = 2; i < 8; i++) {
        if ("nav" + i === "nav" + id) {
          continue;
        } else {
          document.getElementById("nav" + i).style.borderTop =
            "5px solid #dddddd";
        }
      }
      window.scrollTo(0, 0);
    }
  }
};
</script>

<style scoped>
.footer-bs {
  background-color: #3c3d41;
  z-index: 1000000;
  padding: 20px 40px;
  color: rgba(255, 255, 255, 1);
  margin-bottom: 20px;
  border-bottom-right-radius: 6px;
  border-top-left-radius: 0px;
  border-bottom-left-radius: 6px;
  /* margin-top: 150px; */
}
.footer-bs .footer-brand,
.footer-bs .footer-nav,
.footer-bs .footer-social,
.footer-bs .footer-ns {
  padding: 10px 25px;
}
.footer-bs .footer-nav,
.footer-bs .footer-social,
.footer-bs .footer-ns {
  border-color: transparent;
}
.footer-bs .footer-brand h2 {
  margin: 0px 0px 10px;
}
.footer-bs .footer-brand p {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.7);
}

.footer-bs .footer-nav ul.pages {
  list-style: none;
  padding: 0px;
}
.footer-bs .footer-nav ul.pages li {
  padding: 5px 0px;
  color: white !important;
}
.footer-bs .footer-nav ul.pages a {
  color: rgba(255, 255, 255, 1) !important;
  font-weight: bold;
  text-transform: uppercase;
}

.footer-bs .footer-nav ul.pages a:hover {
  color: rgba(255, 255, 255, 0.8) !important;
  text-decoration: none;
}

.footer-bs .footer-nav h4 {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 3px;
  margin-bottom: 10px;
}

.footer-bs .footer-nav ul.list {
  list-style: none;
  padding: 0px;
}
.footer-bs .footer-nav ul.list li {
  padding: 5px 0px;
}
.footer-bs .footer-nav ul.list a {
  color: rgba(255, 255, 255, 0.8);
}
.footer-bs .footer-nav ul.list a:hover {
  color: rgba(255, 255, 255, 0.6);
  text-decoration: none;
}

.footer-bs .footer-social ul {
  list-style: none;
  padding: 0px;
}
.footer-bs .footer-social h4 {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 3px;
}
.footer-bs .footer-social li {
  padding: 5px 4px;
}
.footer-bs .footer-social a {
  color: rgba(255, 255, 255, 1);
}
.footer-bs .footer-social a:hover {
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
}

.footer-bs .footer-ns h4 {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 3px;
  margin-bottom: 10px;
}
.footer-bs .footer-ns p {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.7);
}

@media (min-width: 768px) {
  .footer-bs .footer-nav,
  .footer-bs .footer-social,
  .footer-bs .footer-ns {
    border-left: solid 1px rgba(255, 255, 255, 0.1);
  }
}
</style>
